import React from 'react';
import c from 'classnames';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../../../components/Card';

import './style.scss';

export interface TaxonomyThemeCardChildProps {
  url: string;
  title: string;
  image?: React.ReactNode;
  className?: string;
}

const TaxonomyThemeCardChild: React.FC<TaxonomyThemeCardChildProps> = (props) => {
  const {
    url,
    title,
    image,
    className,
  } = props;

  const classes = c('TaxonomyThemeCard--Child', className);

  return (
    <Card className={classes}>
      {image && (
        <Card.Image image={image} />
      )}
      <Card.Link link={url}>
        <Card.Title title={title} className="label--regular" />
        <div className="Card__icon-wrapper">
          <Icon name="arrow_forward" />
        </div>
      </Card.Link>
    </Card>
  );
};

export default TaxonomyThemeCardChild;
